import { render } from "./QuestionHTML.vue?vue&type=template&id=7510b226"
import script from "./QuestionHTML.vue?vue&type=script&lang=js"
export * from "./QuestionHTML.vue?vue&type=script&lang=js"

import "./QuestionHTML.vue?vue&type=style&index=0&id=7510b226&lang=css"
script.render = render

export default script